<template>
  <div id="app">
    <v-app v-if='appReady' :class="$route.meta.forPrinting ? 'printing' : ''">
      <template v-if='$route.meta.forPrinting' class='print'>
        <router-view></router-view>
      </template>
      <template v-else>
        <wc-main-nav app='Dashboard' v-if='isAuthed'></wc-main-nav>
        <v-main>
          <router-view/>
        </v-main>
        <v-dialog v-model='showErrorDialog' width='300'>
          <v-card>
            <v-card-title>
              <v-icon color='red'>mdi-alert</v-icon>
              Error!
            </v-card-title>
            <v-card-text>
              It seems there was an error talking to the database. The specific error is:<br>
              <br>
              <code>{{ errorResponse }}</code>
            </v-card-text>
            <v-card-actions>
              <save-cancel-buttons
                hideCancel
                saveText='OK'
                @save='showErrorDialog = false'
              ></save-cancel-buttons>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-app>
    <v-app v-else>
      <wc-full-page-loading></wc-full-page-loading>
    </v-app>
  </div>
</template>

<script>
import auth from '@/services/auth';
import WCMainNav from '@/components/nav/WCMainNav';

export default {
  name: 'app',
  data () {
    return {
      appReady: false,
      showErrorDialog: false
    }
  },
  watch: {
    showError (val) {
      if (val) {
        this.showErrorDialog = true
      } else {
        this.showErrorDialog = false
      }
    }
  },
  computed: {
    isAuthed () {
      return this.$store.state.auth.token
    },
    showError () {
      return this.$store.getters.hasApiError
    },
    errorResponse () {
      return this.$store.getters.getErrorResponse
    }
  },
  mounted () {
    this.appReady = false;
    this.setupApp();
  },
  methods: {
    async setupApp () {
      if (this.$route.name !== 'Login') {
        this.appReady = await auth.setStoreValues()
        if (!this.appReady) {
          this.appReady = true
          this.$router.push({ name: 'Login' })
        }
      } else {
        this.appReady = true;
      }
    }
  },
  components: {
    'wc-main-nav': WCMainNav
  }
}
</script>

<style scoped>

.printing {
  background-color: white !important;
}
</style>

